import Walas from "../../../../../components/categories/siakad/lms/data_walas/Home";
export default function Home() {
  
  return (
    <Walas />
  );
}
